import { gql } from 'graphql-tag';
import { templateMappingDetail } from '../mapping/mutations';

export const loginUserMutation = gql`
  mutation($email: String!, $password: String!) {
    login_user(email: $email, password: $password) {
      token
      communities_users {
        id
        admin
        community {
          id
        }
      }
    }
  }
`;

export const resumeSessionMutation = gql`
  mutation ResumeSession($sessionToken: String!) {
    token_session(session_token: $sessionToken) {
      context
      token
      communities_users {
        id
        admin
        community {
          id
        }
      }
    }
  }
`;

export const saveFavoritesMutation = gql`
  mutation saveFavoriteLayout($id: ID!) {
    create_template_user(template_id: $id) {
      id
      template {
        id
        categories {
          id
        }
        title
        preview_image_url
        data
        layout_type
        template_element_mappings {
          ...templateMappingDetail
        }
      }
    }
  }
  ${templateMappingDetail}
`;

export const deleteFavoritesMutation = gql`
  mutation DeleteTemplateUser($id: ID!) {
    delete_template_user(template_id: $id) {
      id
      template {
        id
        categories {
          id
        }
        title
        preview_image_url
        data
        layout_type
      }
    }
  }
`;
